<key-admin-section-editor
    [handler]="handler"
    [editable]="editable"
    [editing]="editing"
    [saveable]="saveable"
    [errorMessage]="errorMessage"
    [actions]="actions"
    (onEdit)="onStartEdit()"
    (onSave)="onSave()"
    (onCancel)="onCancel()"
    (onAction)="onAction($event)"
>
    <div outside class="pb-2 pt-2">
        <key-contacts [contacts]="contacts" [compact]="false" [showDelete]="editing" (onClick)="onEdit($event)" (onDelete)="onDelete($event)"> </key-contacts>
    </div>
</key-admin-section-editor>
